import { AuthGuard, CrudOp, geometryAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { useRequiredProjectParam } from "@org-avp/avp-avengers-ui-shared-store";
import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const GeometryManagerView: FC = () => {
  const brand = useRequiredProjectParam("brand");
  return (
    <AuthGuard authScope={geometryAuthScope} crudOp={CrudOp.READ} brand={brand}>
      <Suspense><LazyGeometryManagerView brand={brand}/></Suspense>
    </AuthGuard>
  );
};

const LazyGeometryManagerView = lazy(importView(
  () => import("../components/GeometryManagerView"),
  (it) => it.GeometryManagerView,
));
